import { List, Map } from 'immutable';
import { createContext } from 'react';

// interface Shortkey {
//   key: string;
//   description: string;
// }

interface Section {
  get: (key: string) => any;
  // TODO: make the attr below work
  // sectionKey: string;
  // shortkeys: readonly Shortkey[];
}

export interface ShortKey {
  section: string;
  key: string;
  description: string;
}

interface ShortkeyContextType {
  shortkeys: readonly Section[];
  registerShortkey: (
    sectionKey: string,
    key: string,
    description: string
  ) => void;
  unregisterShortkey: (sectionKey: string, key: string) => void;
}

export function getShortkeyContextValue(): ShortkeyContextType {
  return {
    shortkeys: this.state.shortkeySections,
    registerShortkey: this.registerShortkey,
    unregisterShortkey: this.unregisterShortkey,
  };
}

export function setupShortkey() {
  try {
    this.state = {
      ...this.state,
      shortkeySections: List(),
    };
  } catch {
    this.state = {
      shortkeySections: List(),
    };
  }
}

// used for top class component for binding
export function registerShortkey(
  sectionKey: string,
  key: string,
  description: string
) {
  this.setState(({ shortkeySections }) => {
    const sectionIndex = shortkeySections.findIndex(
      section => section.get('section') === sectionKey
    );
    const section =
      sectionIndex > -1
        ? shortkeySections.get(sectionIndex)
        : Map({
            section: sectionKey,
            shortkeys: [],
          });
    const newSection = section.update('shortkeys', shortkeys => [
      ...shortkeys.filter(({ key: _key }) => _key !== key),
      {
        key,
        description,
      },
    ]);
    return sectionIndex > -1
      ? {
          shortkeySections: shortkeySections.update(
            sectionIndex,
            () => newSection
          ),
        }
      : {
          shortkeySections: shortkeySections.push(newSection),
        };
  });
}

export function unregisterShortkey(sectionKey: string, key: string) {
  this.setState(({ shortkeySections }) => {
    const sectionIndex = shortkeySections.findIndex(
      section => section.get('section') === sectionKey
    );
    if (sectionIndex === -1) {
      return shortkeySections;
    }
    const section = shortkeySections.get(sectionIndex);
    const newSection = section.update('shortkeys', shortkeys =>
      shortkeys.filter(({ key: _key }) => _key !== key)
    );
    return {
      shortkeySections: shortkeySections.update(sectionIndex, () => newSection),
    };
  });
}

const ShortkeyContext = createContext<ShortkeyContextType>(null);

export default ShortkeyContext;
